<template>
    <toolbar-option type="stacked">
        <template slot="primary">
            <dropdown
                :value="expandValue"
                :options="expandOptions"
                native
                @input="onInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';

const DEFAULT_VALUE = 'default';

export default {
    name: 'control-drawer-expand',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'When Expanding',
            expandValue: DEFAULT_VALUE,

            expandOptions: [
                { text: 'Do nothing', value: DEFAULT_VALUE },
                { text: 'Close other drawers', value: 'close-other-drawers' },
            ],
        };
    },

    methods: {
        onInput(valueNew) {
            this.selectedElements[0].setElementData('drawer-expand', valueNew);
            this.onOptionChange(valueNew);
        },

        onSelectedElement() {
            this.expandValue = this.selectedElements[0].getElementData('drawer-expand') || DEFAULT_VALUE;
        },
    },
};
</script>
